import { htmlEncodeManipulation } from "./IAMUtils";
const ROW_DELIMITER = "~";
export function getCookie(person, namespace, appId) {
  let value = "";

  value = htmlEncodeManipulation(getKiwiCookieValue(person, namespace, appId));

  return value;
}

function getKiwiCookieValue(person, namespace, appId) {
  let value = "";
  value += appId + ROW_DELIMITER;
  value += namespace + ROW_DELIMITER;
  value += person.accountId;
  if (person.oktaAccountId !== null && person.oktaAccountId !== undefined) {
    value += ROW_DELIMITER + person.oktaAccountId;
  }

  return value;
}
